import { BaseViewModel } from "@iot-platform/core";
import { SpatialLevels } from "@station/domain/models/spatial-level.model.ts";
import type { Station } from "@station/domain/models/station.model";
import { SpatialLevelGetAllUseCase } from "@station/domain/usecases/spatial-level-get-all.usecase";
import { StationAddSelectedUseCase } from "@station/domain/usecases/station-add-selected.usecase";
import { StationGetSelectedUseCase } from "@station/domain/usecases/station-get-selected.usecase";
import { inject, injectable } from "inversify";
import { action, makeObservable, observable, runInAction } from "mobx";

@injectable()
export class StationWebPageViewmodel extends BaseViewModel {
    @observable
    spatialLevels: SpatialLevels = SpatialLevels.empty();

    @observable
    selectedStations: readonly Readonly<Station>[] = [];

    constructor(
        @inject(SpatialLevelGetAllUseCase)
        private readonly spatialLevelGetAllUseCase: SpatialLevelGetAllUseCase,
        @inject(StationAddSelectedUseCase)
        private readonly stationAddSelectedUseCase: StationAddSelectedUseCase,
        @inject(StationGetSelectedUseCase)
        private readonly stationGetSelectedUseCase: StationGetSelectedUseCase,
    ) {
        super();
        makeObservable(this);
    }

    @action
    override async didMount(): Promise<void> {
        await this.initViewData();

        this.addSub(
            this.stationGetSelectedUseCase.execute().subscribe((stations) => {
                runInAction(() => {
                    this.selectedStations = stations;
                });
            }),
        );
    }

    async initViewData(): Promise<void> {
        await this.fetchSpatialLevels();
    }

    private async fetchSpatialLevels(): Promise<void> {
        const spatialLevels = await this.spatialLevelGetAllUseCase.execute();

        runInAction(() => {
            this.spatialLevels = spatialLevels;
        });
    }

    @action
    addStation(station: Station): void {
        this.stationAddSelectedUseCase.execute(station);
    }
}
